;(function($){

    function Accrediteds()
    {
    	$("#customer_groups_id").on("change", function(e){
    		e.preventDefault();
    		$(".customer-group").addClass('hidden');       
            $(".customer-group input").attr('disabled', true);
    		$(".type-of-register-"+ $("#type_of_register").val() +" .customer-group-"+ $(this).val()).removeClass('hidden');
            $(".type-of-register-"+ $("#type_of_register").val() +" .customer-group-"+ $(this).val()+ " input").attr('disabled', false);

            $(".type-of-register").addClass('hidden');
            $(".info-type-of-register").addClass('hidden');  
            $(".type-of-register-"+ $("#type_of_register").val()).removeClass('hidden');
            $(".info-type-of-register-"+ $("#type_of_register").val()).removeClass('hidden');

            if ($(this).val() == 1) {
                $(".geocode").addClass('hidden');
                $(".geocode input").attr('disabled', true);
            }else {
                $(".geocode").removeClass('hidden');
                $(".geocode input").attr('disabled', false);
            }
    	});

        $("#type_of_register").on("change", function(e){
            e.preventDefault();
            $(".type-of-register").addClass('hidden'); 
            $(".info-type-of-register").addClass('hidden');      
            $(".type-of-register-"+ $(this).val()).removeClass('hidden');
            $(".info-type-of-register-"+ $(this).val()).removeClass('hidden'); 

            $(".customer-group").addClass('hidden');
            $(".customer-group input").attr('disabled', true);
            $(".type-of-register-"+ $("#type_of_register").val() +" .customer-group-"+ $("#customer_groups_id").val()).removeClass('hidden');
            $(".type-of-register-"+ $("#type_of_register").val() +" .customer-group-"+ $("#customer_groups_id").val() + " input").attr('disabled', false);
      
        });

    	if($("#customer_groups_id").val() != "")
    	{
    		$(".customer-group").addClass('hidden');
            $(".customer-group input").attr('disabled', true);
    		$(".type-of-register-"+ $("#type_of_register").val() +" .customer-group-"+ $("#customer_groups_id").val()).removeClass('hidden');
            $(".type-of-register-"+ $("#type_of_register").val() +" .customer-group-"+ $("#customer_groups_id").val() + " input").attr('disabled', false);

            if ($("#customer_groups_id").val() == 1) {
                $(".geocode").addClass('hidden');
                $(".geocode input").attr('disabled', true);
            }else {
                $(".geocode").removeClass('hidden');
                $(".geocode input").attr('disabled', false);
            }
    	}

        if($("#type_of_register").val() != "")
        {
            $(".type-of-register").addClass('hidden');
            $(".info-type-of-register").addClass('hidden');  
            $(".type-of-register-"+ $("#type_of_register").val()).removeClass('hidden');
            $(".info-type-of-register-"+ $("#type_of_register").val()).removeClass('hidden');
        }
    }

   	new Accrediteds();

}(jQuery));
 
 
 
 
